import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import { login, DdbHttpError } from "@/lib/ddb";

export function LoginPage() {
  const nav = useNavigate();
  const [user, setUser] = useState("dba");
  const [pwd, setPwd] = useState("dba");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await login(user, pwd);
      nav("/projects", { replace: true });
    } catch (e) {
      if (e instanceof DdbHttpError && e.status === 401) {
        setErr("Invalid credentials.");
      } else {
        setErr(e instanceof Error ? e.message : String(e));
      }
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-page">
      <form className="card login-card" onSubmit={submit}>
        <h1>Cabinet Studio</h1>
        <div className="subtitle">Sign in to your ddb workspace.</div>

        <div className="row">
          <label className="label" htmlFor="u">Username</label>
          <input
            id="u"
            type="text"
            autoComplete="username"
            value={user}
            onChange={(e) => setUser(e.target.value)}
            disabled={busy}
            required
          />
        </div>

        <div className="row">
          <label className="label" htmlFor="p">Password</label>
          <input
            id="p"
            type="password"
            autoComplete="current-password"
            value={pwd}
            onChange={(e) => setPwd(e.target.value)}
            disabled={busy}
            required
          />
        </div>

        <button type="submit" disabled={busy || !user || !pwd}>
          {busy ? "Signing in…" : "Sign in"}
        </button>

        {err && <div className="error">{err}</div>}

        <div className="muted" style={{ marginTop: 16, fontSize: 12 }}>
          Default admin: <code>dba / dba</code> when the server is started with
          {" "}<code>--dba-password dba</code>.
        </div>
      </form>
    </div>
  );
}
